import { forwardRef, Children } from 'react';
import { getOptionListStyles } from './OptionListStyles.js';
import { OPTION_HEIGHT, OPTION_HEIGHT_DOUBLE_LINE } from '../Option/OptionStyles.js';
import { jsx } from '@emotion/react/jsx-runtime';

const OptionList = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    maxVisibleOptions = 5,
    addHalfOption = true,
    children,
    ...rest
  } = _ref;
  const totalNumberOfItems = Children.toArray(children).length;
  const itemsWithSublabel = Children.toArray(children).filter(child => child.props.hasSublabel === true).length;
  const height = maxVisibleOptions >= totalNumberOfItems ? undefined : getComponentHeight(totalNumberOfItems, itemsWithSublabel, maxVisibleOptions, addHalfOption);
  return jsx("div", {
    role: "menu",
    tabIndex: 0,
    ref: ref,
    css: getOptionListStyles(height),
    ...rest,
    children: children
  });
});
OptionList.displayName = 'OptionList';
const getComponentHeight = (totalNumberOfItems, itemsWithSublabel, maxVisibleOptions, addHalfOption) => {
  const itemsWithoutSublabel = totalNumberOfItems - itemsWithSublabel;
  const roundedMaxVisibleOptions = maxVisibleOptions + (addHalfOption ? 0.5 : 0);
  const heightWithoutSublabel = OPTION_HEIGHT * itemsWithoutSublabel * roundedMaxVisibleOptions;
  const heightWithSublabel = OPTION_HEIGHT_DOUBLE_LINE * itemsWithSublabel * roundedMaxVisibleOptions;
  return (heightWithoutSublabel + heightWithSublabel) / totalNumberOfItems;
};

export { OptionList };
//# sourceMappingURL=OptionList.js.map
